import { HTMLProps } from 'react';
import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { CheckboxIconName } from './types';
import { Icon } from './Icon';

export type CheckboxIconProps = Omit<HTMLProps<HTMLElement>, 'checked'> & {
  checked?: boolean | null;
  mixed?: boolean;
  isFocused?: boolean;
};

const getIconName = (
  checked: boolean | null,
  mixed?: boolean
): CheckboxIconName => {
  if (mixed) return CheckboxIconName.PARTIALLY_CHECKED;
  if (checked === null) return CheckboxIconName.UNSET;
  if (checked) return CheckboxIconName.CHECKED;
  return CheckboxIconName.UNCHECKED;
};

const CheckboxIconStyle = styled(Icon)<{
  $isActive?: boolean;
}>`
  color: ${({ $isActive }) => ($isActive ? colors.blue600 : colors.grey700)};
  &:hover {
    color: ${({ $isActive }) => ($isActive ? colors.blue700 : colors.grey900)};
  }
`;

export const CHECKBOX_ICON_SELECTOR = CheckboxIconStyle.toString();

export const CheckboxIcon = ({
  checked = null,
  mixed,
  ...rest
}: CheckboxIconProps) => {
  return (
    <CheckboxIconStyle
      data-testid="checkbox"
      iconName={getIconName(checked, mixed)}
      $isActive={checked || mixed}
      {...(rest as Record<string, unknown>)}
    />
  );
};
